import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, isAdmin, checking } = useAuth();
  const loc = useLocation();

  if (checking) return <div style={{padding:24}}>...جارِ التحقق</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (!isAdmin) return <div style={{padding:24}}>هذا الحساب غير مخوّل للوصول.</div>;

  return children;
}
